export default __webpack_public_path__ + "static/media/refresh.d384bb69.svg";